var map = {
	"./button-text-block-quote-on.svg": 2761,
	"./button-text-block-quote.svg": 2762,
	"./button-text-bold-on.svg": 2763,
	"./button-text-bold.svg": 2764,
	"./button-text-bulleted-list-on.svg": 2765,
	"./button-text-bulleted-list.svg": 2766,
	"./button-text-deleted-on.svg": 2767,
	"./button-text-deleted.svg": 2768,
	"./button-text-formatting.svg": 1246,
	"./button-text-inline-code-on.svg": 2769,
	"./button-text-inline-code.svg": 2770,
	"./button-text-italic-on.svg": 2771,
	"./button-text-italic.svg": 2772,
	"./button-text-numbered-list-on.svg": 2773,
	"./button-text-numbered-list.svg": 2774,
	"./button-text-underlined-on.svg": 2775,
	"./button-text-underlined.svg": 2776
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2760;